import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CameraIcon, MapPinIcon, StarIcon, ArrowLeftIcon, CalendarIcon, ClockIcon, CheckIcon, XIcon, BookIcon, UserIcon } from 'lucide-react';
import BackButton from '../../components/UI/BackButton';
// Mock data - in a real app, this would come from an API
interface PortfolioItem {
  id: number;
  imageUrl: string;
  title: string;
  category: string;
  client?: string;
  bookId?: string;
  description?: string;
  date: string;
  modelInfo?: {
    name: string;
    id: string;
  };
}
interface ContentUsage {
  id: number;
  imageUrl: string;
  title: string;
  type: 'book' | 'merchandise';
  author: string;
  authorId: string;
  bookId?: string;
  productId?: string;
  releaseDate: string;
  genre: string;
  series?: {
    name: string;
    position: number;
  };
  model?: {
    name: string;
    id: string;
  };
}
const photographersData = [{
  id: 1,
  name: 'Sarah Chen',
  location: 'New York, NY',
  specialties: ['Author Portraits', 'Book Covers', 'Editorial'],
  rating: 4.9,
  reviewCount: 124,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  availability: 'Available Now',
  priceRange: '$500-1000',
  bio: 'Professional photographer with over 8 years of experience specializing in book cover photography and author portraits. I work with authors, publishers, and models to create compelling visual stories that capture the essence of your book.',
  equipment: ['Sony Alpha a7 III', 'Canon EOS R5', 'Professional Lighting Setup'],
  experience: '8 years',
  education: 'BFA in Photography, New York School of Visual Arts',
  languages: ['English', 'Mandarin'],
  bookings: [{
    month: 'June',
    availability: 'Limited'
  }, {
    month: 'July',
    availability: 'Available'
  }, {
    month: 'August',
    availability: 'Available'
  }],
  portfolio: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1614813651945-964c6686e3e8',
    title: 'Fantasy Book Cover',
    category: 'Book Cover',
    client: 'Elena Richards',
    bookId: 'the-silent-echo',
    description: 'Cover photo for bestselling fantasy novel',
    date: '2023-03-15',
    modelInfo: {
      name: 'Elena Martinez',
      id: '1'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
    title: 'Author Portrait',
    category: 'Portrait',
    client: 'Marcus Chen',
    description: 'Professional headshot for author website and marketing',
    date: '2023-04-22'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85',
    title: 'Mystery Thriller Cover',
    category: 'Book Cover',
    client: 'James Wilson',
    bookId: 'night-hunter',
    description: 'Atmospheric photo for thriller novel',
    date: '2023-02-10',
    modelInfo: {
      name: 'James Wilson',
      id: '2'
    }
  }, {
    id: 4,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb',
    title: 'Romance Novel Cover',
    category: 'Book Cover',
    client: 'Sarah Johnson',
    bookId: 'summer-heat',
    description: 'Contemporary romance cover shoot',
    date: '2023-05-05',
    modelInfo: {
      name: 'Sofia Chen',
      id: '3'
    }
  }, {
    id: 5,
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
    title: 'Author Brand Shoot',
    category: 'Editorial',
    client: 'David Kim',
    description: 'Multi-purpose editorial shoot for author marketing',
    date: '2023-01-30'
  }, {
    id: 6,
    imageUrl: 'https://images.unsplash.com/photo-1618022325802-7e5e732d97a1',
    title: 'Historical Fiction Cover',
    category: 'Book Cover',
    client: 'Maria Garcia',
    bookId: 'echoes-of-time',
    description: 'Period-authentic styling for historical fiction',
    date: '2023-04-02'
  }],
  contentUsage: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1614813651945-964c6686e3e8',
    title: 'The Silent Echo',
    type: 'book',
    author: 'Elena Richards',
    authorId: 'elena-richards',
    bookId: 'the-silent-echo',
    releaseDate: '2023-04-15',
    genre: 'Fantasy',
    model: {
      name: 'Elena Martinez',
      id: '1'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85',
    title: 'Night Hunter',
    type: 'book',
    author: 'James Wilson',
    authorId: 'james-wilson',
    bookId: 'night-hunter',
    releaseDate: '2023-03-10',
    genre: 'Thriller',
    model: {
      name: 'James Wilson',
      id: '2'
    }
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb',
    title: 'Summer Heat',
    type: 'book',
    author: 'Sarah Johnson',
    authorId: 'sarah-johnson',
    bookId: 'summer-heat',
    releaseDate: '2023-05-20',
    genre: 'Romance',
    series: {
      name: 'Seasons of Love',
      position: 1
    },
    model: {
      name: 'Sofia Chen',
      id: '3'
    }
  }],
  reviews: [{
    id: 1,
    author: 'Elena Richards',
    authorRole: 'Fantasy Author',
    rating: 5,
    comment: 'Sarah captured exactly what I wanted for my book cover. The composition and lighting were perfect, and she made the entire process easy and enjoyable. Would absolutely work with her again!',
    date: '2023-04-18'
  }, {
    id: 2,
    author: 'Maria Garcia',
    authorRole: 'Historical Fiction Author',
    rating: 5,
    comment: "Incredible attention to detail and period accuracy. Sarah researched the historical era of my book and ensured everything from the model, s, pose, to, the, lighting, matched, the, time, period, : .True, professional, ',: date, '2023-04-10"
  }, {
    id: 3,
    author: 'James Wilson',
    authorRole: 'Thriller Author',
    rating: 4,
    comment: 'Great work on my thriller cover. Sarah knows how to create the perfect mood and atmosphere for genre fiction. The final images were exactly what my book needed.',
    date: '2023-03-15'
  }]
}
// More photographers could be added here
];
const PhotographerPortfolio = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState<'portfolio' | 'reviews' | 'booking' | 'content'>('portfolio');
  // Find the photographer based on the ID from the URL
  const photographer = photographersData.find(p => p.id === parseInt(id || '0'));
  if (!photographer) {
    return <div className="min-h-screen bg-gray-50 py-8 px-4" data-id="element-14804" data-mp="3b64rebhopmy6">
        <div className="max-w-7xl mx-auto text-center" data-id="element-14805" data-mp="3g6aeded0el9x">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-14806" data-mp="31a1goh8rofzm">
            Photographer Not Found
          </h1>
          <p className="text-lg text-gray-600 mb-8" data-id="element-14807" data-mp="369nscm8y5o6b">
            The photographer you're looking for doesn't exist or has been
            removed.
          </p>
          <Link to="/talent/photographers" className="inline-flex items-center bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-14808" data-mp="2sbg1mw2i7j3l">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-14809" data-mp="qfx84ek60gmh" />
            Back to Photographers
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14810" data-mp="241s43hnn3nj7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14811" data-mp="243momuv01dmr">
        {/* Back Button */}
        <div className="mb-6" data-id="element-14812" data-mp="1z37c25ijka5u">
          <BackButton data-id="element-14813" data-mp="1ubgzru01ncbs" />
        </div>
        {/* Photographer Header */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8" data-id="element-14814" data-mp="1u9mdab94jc5l">
          <div className="md:flex" data-id="element-14815" data-mp="1q9lzmstun4zl">
            <div className="md:w-1/3" data-id="element-14816" data-mp="1lb0y8q2v2f9k">
              <img src={photographer.imageUrl} alt={photographer.name} className="w-full h-96 object-cover" data-id="element-14817" data-mp="1lc29ovnsh3rt" />
            </div>
            <div className="p-6 md:w-2/3" data-id="element-14818" data-mp="1bc33h5eudpi4">
              <div className="flex justify-between items-start" data-id="element-14819" data-mp="1bd4nhzdu5mbz">
                <div data-id="element-14820" data-mp="17cb1jbjyehlq">
                  <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-14821" data-mp="17d2mlsfxcwxr">
                    {photographer.name}
                  </h1>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-14822" data-mp="31pam7j36y1zv">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-14823" data-mp="31ng1o5vu0bwb" />
                    {photographer.location}
                  </div>
                </div>
                <div className="flex items-center bg-yellow-50 px-3 py-1 rounded-full" data-id="element-14824" data-mp="sft6ane0etno">
                  <StarIcon className="h-5 w-5 text-yellow-400 mr-1" data-id="element-14825" data-mp="x6t2fqfb17p4" />
                  <span className="font-medium text-gray-900" data-id="element-14826" data-mp="118wp7b7fbypp">
                    {photographer.rating}
                  </span>
                  <span className="text-gray-500 ml-1" data-id="element-14827" data-mp="4jfa65mjx0bc">
                    ({photographer.reviewCount} reviews)
                  </span>
                </div>
              </div>
              <div className="mb-6" data-id="element-14828" data-mp="djlk5hj1ji5r">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-14829" data-mp="diak9sspuujx">
                  About
                </h2>
                <p className="text-gray-600" data-id="element-14830" data-mp="ijzqmv4zuk1o">{photographer.bio}</p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-14831" data-mp="1oxpdclht129r">
                <div data-id="element-14832" data-mp="1twskcbhchikd">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-14833" data-mp="1twac0gherdw3">
                    Experience
                  </h3>
                  <p className="text-gray-900" data-id="element-14834" data-mp="m6s4zhrnmp07">{photographer.experience}</p>
                </div>
                <div data-id="element-14835" data-mp="r64njqbht9wz">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-14836" data-mp="vypgyqqhlkzz">
                    Education
                  </h3>
                  <p className="text-gray-900" data-id="element-14837" data-mp="10yafx15nptcp">{photographer.education}</p>
                </div>
                <div data-id="element-14838" data-mp="3ajvg1rlzrz3">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-14839" data-mp="3b20nnw91gj5">
                    Price Range
                  </h3>
                  <p className="text-gray-900" data-id="element-14840" data-mp="89dbo1ya5x2y">{photographer.priceRange}</p>
                </div>
                <div data-id="element-14841" data-mp="d6wnywbf3zs9">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-14842" data-mp="dakhhvgv4m6z">
                    Availability
                  </h3>
                  <p className="text-green-600" data-id="element-14843" data-mp="1onwepni4a6k6">{photographer.availability}</p>
                </div>
              </div>
              <div className="mb-6" data-id="element-14844" data-mp="1snx4g4ao246j">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-14845" data-mp="1sn5b704jkijf">
                  Specialties
                </h2>
                <div className="flex flex-wrap gap-2" data-id="element-14846" data-mp="395dxqxz5s5cp">
                  {photographer.specialties.map(specialty => <span key={specialty} className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full" data-id="element-14847" data-mp="34e5rubx1f24a">
                      {specialty}
                    </span>)}
                </div>
              </div>
              <div className="flex gap-4" data-id="element-14848" data-mp="2ph574sd9k7fb">
                <button className="px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors w-full md:w-auto" data-id="element-14849" data-mp="2pg3jzpiz3uh8">
                  Contact for Booking
                </button>
                <button className="px-4 py-3 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-50 transition-colors w-full md:w-auto" data-id="element-14850" data-mp="2gikxegpol838">
                  Save to Favorites
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className="mb-6 border-b border-gray-200" data-id="element-14851" data-mp="xsoyox7toph2">
          <nav className="flex space-x-8" data-id="element-14852" data-mp="12kylw5hjzbfn">
            <button onClick={() => setActiveTab('portfolio')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'portfolio' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-14853" data-mp="12mt9jrk7lhnf">
              Portfolio
            </button>
            <button onClick={() => setActiveTab('content')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'content' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-14854" data-mp="1ljugvj18jtuj">
              Published Works
            </button>
            <button onClick={() => setActiveTab('reviews')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-14855" data-mp="3sc3o4h7wpftw">
              Reviews ({photographer.reviews.length})
            </button>
            <button onClick={() => setActiveTab('booking')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'booking' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-14856" data-mp="2kd1fee3a1p2">
              Availability
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        {activeTab === 'portfolio' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-14857" data-mp="3b0yeb69udexg">
            {photographer.portfolio.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:-translate-y-1 transition-transform duration-200" data-id="element-14858" data-mp="2n9arazfpao0g">
                <div className="relative aspect-[4/3]" data-id="element-14859" data-mp="2vwn6bdxkeidc">
                  <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-14860" data-mp="30x1d6snfjm9s" />

                  <div className="absolute top-2 right-2" data-id="element-14861" data-mp="3ane1mvyd7zl7">
                    <div className="bg-white/80 text-xs font-medium px-2 py-1 rounded" data-id="element-14862" data-mp="3apqptqupv66p">
                      {new Date(item.date).toLocaleDateString('en-US', {
                  month: 'short',
                  year: 'numeric'
                })}
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-14863" data-mp="3tm8h675nl42f">
                  <h3 className="font-medium text-gray-900 mb-1" data-id="element-14864" data-mp="3tl6z3iq7zhb7">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between mb-2" data-id="element-14865" data-mp="1ubh1uxudzjge">
                    <span className="text-xs px-2 py-1 bg-purple-100 text-purple-700 rounded-full" data-id="element-14866" data-mp="1z9a97u7feji9">
                      {item.category}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-14867" data-mp="bm4e2b3rgoyr">
                      {item.client && `for ${item.client}`}
                    </span>
                  </div>
                  {item.description && <p className="text-sm text-gray-600 mb-2" data-id="element-14868" data-mp="2n0vd88iabks">
                      {item.description}
                    </p>}
                  {item.modelInfo && <div className="text-xs text-gray-500" data-id="element-14869" data-mp="va3ofkuexu3n">
                      Model:{' '}
                      <Link to={`/talent/models/${item.modelInfo.id}/portfolio`} className="text-purple-600 hover:text-purple-800" data-id="element-14870" data-mp="qb0v2xnspcbi">
                        {item.modelInfo.name}
                      </Link>
                    </div>}
                  {item.bookId && <div className="mt-2" data-id="element-14871" data-mp="364rgv9s86rxg">
                      <Link to={`/book/${item.bookId}`} className="text-xs flex items-center text-purple-600 hover:text-purple-800" data-id="element-14872" data-mp="37jlru9iyxjym">
                        <BookIcon className="h-3 w-3 mr-1" data-id="element-14873" data-mp="2yjyo3h2ro22e" />
                        View Book
                      </Link>
                    </div>}
                </div>
              </div>)}
          </div>}
        {activeTab === 'content' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-14874" data-mp="2tkm3z43a593i">
            {photographer.contentUsage.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:-translate-y-1 transition-transform duration-200" data-id="element-14875" data-mp="2fqurbmu9593k">
                <Link to={item.type === 'book' ? `/book/${item.bookId}` : `/product/${item.productId}`} className="block" data-id="element-14876" data-mp="25wkxs1tkq4r9">
                  <div className="relative aspect-[2/3]" data-id="element-14877" data-mp="1m9zxsapu2ia2">
                    <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-14878" data-mp="215pcdnsovt4r" />

                    {item.series && <div className="absolute top-2 left-0" data-id="element-14879" data-mp="2a5lut7ohjvrd">
                        <div className="bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded-r" data-id="element-14880" data-mp="257kaykj8jseu">
                          {item.series.name} #{item.series.position}
                        </div>
                      </div>}
                    <div className="absolute bottom-2 right-2" data-id="element-14881" data-mp="2eyot1t47jtdw">
                      <div className="bg-amber-100 text-amber-800 text-xs font-medium px-2 py-1 rounded-full" data-id="element-14882" data-mp="2swn4apn8f9p6">
                        {new Date(item.releaseDate).getFullYear()}
                      </div>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-14883" data-mp="3vclqz6h8xch8">
                    <h3 className="font-medium text-gray-900 mb-1" data-id="element-14884" data-mp="43ooztjuougn">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mb-2" data-id="element-14885" data-mp="94m602t4jigk">
                      <Link to={`/author/${item.authorId}`} className="text-sm text-purple-600 hover:text-purple-800" data-id="element-14886" data-mp="d5egezdqftef">
                        {item.author}
                      </Link>
                      <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-14887" data-mp="3hjco7onszp7o">
                        {item.genre}
                      </span>
                    </div>
                    {item.model && <div className="text-xs text-gray-500" data-id="element-14888" data-mp="2tticxbj4u8pj">
                        Model:{' '}
                        <Link to={`/talent/models/${item.model.id}/portfolio`} className="text-purple-600 hover:text-purple-800" data-id="element-14889" data-mp="2xv3qkz3hqr0s">
                          {item.model.name}
                        </Link>
                      </div>}
                  </div>
                </Link>
              </div>)}
          </div>}
        {activeTab === 'reviews' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14890" data-mp="2cdxm6dw6itz6">
            <div className="p-6" data-id="element-14891" data-mp="27di6vgsc7cek">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-14892" data-mp="27el19yovbwz8">
                Client Reviews
              </h2>
              <div className="space-y-6" data-id="element-14893" data-mp="1xmnmkhynimvr">
                {photographer.reviews.map(review => <div key={review.id} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0" data-id="element-14894" data-mp="1tllmjywwu6sq">
                    <div className="flex justify-between mb-2" data-id="element-14895" data-mp="1oobltn42m8pl">
                      <div data-id="element-14896" data-mp="1jogwhnzy1r6n">
                        <h3 className="font-medium text-gray-900" data-id="element-14897" data-mp="1jp8t925a1uyi">
                          {review.author}
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-14898" data-mp="1dfzl0xa3vj5k">
                          {review.authorRole}
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-14899" data-mp="18ipx5m2d7fju">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-14900" data-mp="zfyhtb6dbzmx" data-mpi={i} />)}
                      </div>
                    </div>
                    <p className="text-gray-600 mb-2" data-id="element-14901" data-mp="kr2cvmzlz2qj">{review.comment}</p>
                    <p className="text-sm text-gray-500" data-id="element-14902" data-mp="ksvkb4i1pqzl">{review.date}</p>
                  </div>)}
              </div>
            </div>
          </div>}
        {activeTab === 'booking' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14903" data-mp="bsqdowkoewmh">
            <div className="p-6" data-id="element-14904" data-mp="2nd6e0jossm4q">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-14905" data-mp="2rfb0mygtwihv">
                Booking Availability
              </h2>
              <div className="mb-8" data-id="element-14906" data-mp="2wdw0uxw2z26b">
                <h3 className="font-medium text-gray-900 mb-4" data-id="element-14907" data-mp="2wexijl7lqmx0">Equipment</h3>
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-14908" data-mp="31cfrvcpj745j">
                  {photographer.equipment.map(item => <span key={item} className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full" data-id="element-14909" data-mp="23rb9vyjios3a">
                      {item}
                    </span>)}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-14910" data-mp="2ifejrj0oknxd">
                {photographer.bookings.map(booking => <div key={booking.month} className="border rounded-lg p-4" data-id="element-14911" data-mp="1kx4ns0tbw4qn">
                    <div className="flex items-center justify-between mb-4" data-id="element-14912" data-mp="1pwr0881c1gye">
                      <div className="flex items-center" data-id="element-14913" data-mp="1hwkuv6bdaxcb">
                        <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-14914" data-mp="1dw0yi4ymbxr8" />
                        <h3 className="font-medium text-gray-900" data-id="element-14915" data-mp="1dty4l9uchkh8">
                          {booking.month}
                        </h3>
                      </div>
                      {booking.availability === 'Available' ? <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-14916" data-mp="yy8hf8dfb1ax">
                          Available
                        </span> : booking.availability === 'Limited' ? <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-14917" data-mp="18xqy9fy1e6yr">
                          Limited
                        </span> : <span className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full" data-id="element-14918" data-mp="2katfmd7yn0jz">
                          Booked
                        </span>}
                    </div>
                    <div className="space-y-2" data-id="element-14919" data-mp="13peyeest6fw">
                      <div className="flex items-center" data-id="element-14920" data-mp="643oy1zymqgk">
                        {booking.availability === 'Available' ? <CheckIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-14921" data-mp="3ob05rgfeccvu" /> : booking.availability === 'Limited' ? <ClockIcon className="h-4 w-4 text-yellow-500 mr-2" data-id="element-14922" data-mp="3tb5rkfyzj560" /> : <XIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-14923" data-mp="outr1ohpi98d" />}
                        <span className="text-gray-600" data-id="element-14924" data-mp="owo4khqnez2f">
                          {booking.availability === 'Available' ? 'Open for bookings' : booking.availability === 'Limited' ? 'Some dates available' : 'Fully booked'}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div className="mt-8" data-id="element-14925" data-mp="3g0atw7c0s737">
                <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors w-full" data-id="element-14926" data-mp="3b2svvbzjjc9z">
                  Contact for Booking
                </button>
                <p className="text-sm text-gray-500 text-center mt-2" data-id="element-14927" data-mp="322vzspatnb4w">
                  Send an enquiry to discuss your project and check detailed
                  availability
                </p>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default PhotographerPortfolio;